export const ADD_SUCCESS = 'Новая марка автомобиля добавлена';
export const ADD_ERROR = 'Не удалось добавить марку автомобиля';
